import { Box, Typography } from '@mui/material';
import React from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  sendOtpForInvestorWithoutPan,
  sendConsentEmailWithoutPan,
} from '../../redux-store/actions/onBoarding';
import {
  ApplicationProps,
  SendConsentEmailResponseBody,
  SendOtpResponseBody,
} from '../../redux-store/types/api-types';
import { emailRegex, nonDigitRegex, phoneRegExp } from '../../utils/regex';
import { Location } from 'history';
import { DatePicker } from '../../lib/formik/DatePicker';
import {
  getCountryCodes,
  getFieldLabelForGuardian,
  getIdTypeDropDown,
  isIdTypeOutOfList,
  isMinor,
  isNonIndividualApplication,
  preventSpecialCharacters,
} from '../../utils/utilityFunctions';
import {
  ACCOUNT_TYPE_MASTER,
  ENABLE_Email_Consent,
  ENABLE_EMAIL_OTP,
  FLOW_TYPE_MASTER,
  FUND_FLOW_TYPE_MASTER,
  IS_DOB_APPLICABLE_FOR_AMC,
  ONBOARDING_ID_TYPES_MASTER,
  ONBOARDING_INVESTOR,
  ONBOARDING_OPTIONS,
  USER_ROLES,
} from '../../utils/constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { CountryCodesDropDown } from '../commonComponents';
import UseRadioGroup from '../../lib/formik/Radio';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';
import MFSelectField from '../../lib/formik/SelectField';
import theme from '../../themes';
import {
  addJointHolder,
  addJointHolderWithoutPan,
  createApplication,
  createApplicationWithoutPan,
} from '../../redux-store/actions/application';
// import { CreateApplicationRequestBody } from '../../redux-store/types/application';
interface Values {
  taxIdNumber: string;
  dob: string;
  countryCode: string;
  countryNameAndCode: string;
  applicationType: string;
  onboardingType: string;
  mobile: string;
  emailId: string;
  name: string;
  onboardingIdType: string;
  onboardingIdTypeOthers: string;
  onboardingOtpEmailConsent?: string;
}

interface MValues {
  pan: string;
  mobile?: string;
  bypassOtp: boolean;
  skipOtpModal: boolean;
  emailId: string;
  hasPOA: boolean;
  dob: string;
  countryCode: string;
  countryNameAndCode: string;
  onboardingOtpEmailConsent?: string;
}
interface EValues {
  pan: string;
  emailId: string;
  dob: string;
}

export default function EnterPAN({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
    flowType: string;
    fundFlowType: string;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    firstHolderName = '',
    application,
    flowType = '',
    fundFlowType = '',
  } = location.state || {};
  const { id, applicants = [], hasPOA } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const applicantPanNumbers = applicants.map((applicant) => applicant.taxIdNumber);
  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
  const validationSchema1 = yup.object().shape({
    taxIdNumber: yup
      .string()
      // .max(20, 'Invalid Tax ID')
      //.matches(alphaNumeric, 'Special characters are not allowed')
      .test('taxIdNumber', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'Id number is required',
            path,
          });
        }
        if (applicantPanNumbers.includes(fieldValue)) {
          return createError({
            message:
              'There is already same Id number for an applicant associated with this application',
            path,
          });
        }
        return true;
      }),
    dob: yup.string().test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (IS_DOB_APPLICABLE_FOR_AMC) {
        if (!fieldValue) {
          return createError({
            message: 'Date of birth is required',
            path,
          });
        }
        if (
          fieldValue &&
          isMinor(fieldValue) &&
          ONBOARDING_INVESTOR[parent.applicationType] === ONBOARDING_INVESTOR.individual
        ) {
          return createError({
            message: 'Date of birth should be greater than 18',
          });
        }
        // if (isMinor(fieldValue || '') && parent.pan?.split('')[3] === 'P') {
        //   return createError({
        //     message: 'Age should be greater than 18',
        //     path,
        //   });
        // }
        // if (maxAge(fieldValue || '') && parent.pan?.split('')[3] === 'P') {
        //   return createError({
        //     message: 'Age should be less than 125',
        //     path,
        //   });
        // }
      }

      return true;
    }),
    emailId: yup.string().test('emailId', (value, context) => {
      const { createError, path } = context;
      if (!value) {
        return createError({
          message: 'Email Id is required',
          path,
        });
      }
      if (!emailRegex.test(value)) {
        return createError({
          message: 'Invalid Email Id',
          path,
        });
      }
      return true;
    }),

    mobile: yup.string().test('mobile', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (
        !value &&
        ONBOARDING_INVESTOR[parent.applicationType] === ONBOARDING_INVESTOR.non_individual
      ) {
        return true;
      }
      if (!value) {
        return createError({
          message: 'Mobile number is required',
          path,
        });
      }
      // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
      //   return createError({
      //     message: 'Invalid Mobile number',
      //     path,
      //   });
      // }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }
      if (applicantMobileNumbers.includes(value)) {
        return createError({
          message:
            'There is already same mobile number for an applicant associated with this application',
          path,
        });
      }
      return true;
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .test('countryNameAndCode', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === value) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (
          !value &&
          ONBOARDING_INVESTOR[parent.applicationType] === ONBOARDING_INVESTOR.non_individual
        ) {
          return true;
        }
        if (!value) {
          return createError({
            message: 'Country Code is required',
            path,
          });
        }
        if (
          parent.mobile &&
          !isValidPhoneNumber(value?.split(':')[1].trim() + parent.mobile, codesList as CountryCode)
        ) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }

        return true;
      }),
    applicationType: yup.string().nullable().required('Onboarding Investor Type is required'),
    onboardingType: yup
      .string()
      .nullable()
      .when('applicationType', {
        is: (applicationType: string) =>
          ONBOARDING_INVESTOR[applicationType] === ONBOARDING_INVESTOR.individual,
        then: yup.string().nullable().required('Account Type is required'),
      }),
    name: yup.string().nullable().required('Name is required'),
    onboardingIdType: yup
      .string()
      .nullable()
      .required('Id type is required')
      .test('onboardingIdType', (value, context) => {
        const { path, createError, parent } = context;
        if (value && !getIdTypeDropDown(parent.applicationType).includes(value)) {
          return createError({
            message: 'Invalid value for id type',
            path,
          });
        }
        return true;
      }),
    onboardingIdTypeOthers: yup.string().when('onboardingIdType', {
      is: (onboardingIdType: string) => isIdTypeOutOfList(onboardingIdType),
      then: yup.string().nullable().required('Id name is required'),
    }),
  });
  const initialValues1: Values = {
    taxIdNumber: '',
    dob: '',
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    applicationType: id && redirectTo ? 'individual' : '',
    onboardingType: 'normal',
    mobile: '',
    emailId: '',
    name: '',
    onboardingIdType: '',
    onboardingIdTypeOthers: '',
    onboardingOtpEmailConsent: 'otp',
  };

  const handleSubmit1 = async (values: Values) => {
    try {
      const {
        taxIdNumber,
        dob,
        applicationType,
        onboardingType,
        countryCode,
        countryNameAndCode,
        mobile: mobileNumber,
        emailId,
        name,
        onboardingIdType,
        onboardingIdTypeOthers,
        onboardingOtpEmailConsent = 'otp',
      } = values;

      if (ONBOARDING_OPTIONS[onboardingOtpEmailConsent] === ONBOARDING_OPTIONS.email_consent) {
        (await dispatch(
          sendConsentEmailWithoutPan({
            taxIdNumber,
            dob,
            applicationType,
            onboardingType,
            countryCode: countryNameAndCode?.split(':')[1].trim(),
            countryNameAndCode,
            mobileNumber: mobileNumber ? mobileNumber?.toString()?.trim() : '',
            emailId,
            name,
            onboardingIdType,
            onboardingIdTypeOthers,
            flowType,
            fundFlowType,
            ...(id ? { applicationId: id || '' } : {}),
          })
        )) as unknown as SendConsentEmailResponseBody;
        enqueueSnackbar('Email sent successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        return history.push(
          [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
            ? `/applications-list`
            : '/applications'
        );
      }

      // const response = (await dispatch(
      //   sendOtpForInvestorWithoutPan({
      //     taxIdNumber,
      //     dob,
      //     applicationType,
      //     onboardingType,
      //     countryCode: countryNameAndCode?.split(':')[1].trim(),
      //     countryNameAndCode,
      //     mobileNumber,
      //     emailId,
      //     name,
      //     onboardingIdType,
      //     onboardingIdTypeOthers,
      //     flowType: flowType,
      //   })
      // )) as unknown as SendOtpResponseBody;

      // const { applicantVerificationToken, phoneNumber } = response || {};

      if (id && redirectTo) {
        const res = (await dispatch(
          addJointHolderWithoutPan(
            {
              taxIdNumber,
              dob,
              applicationType,
              onboardingType,
              countryCode: countryNameAndCode?.split(':')[1].trim(),
              countryNameAndCode,
              mobileNumber: mobileNumber ? mobileNumber?.toString()?.trim() : '',
              emailId,
              name,
              onboardingIdType,
              onboardingIdTypeOthers,
              flowType,
              fundFlowType,
            },
            id,
            flowType
          )
        )) as unknown as ApplicationProps;
        history.push(redirectTo, { ...(res || {}) });
        return;
      }
      const res = (await dispatch(
        createApplicationWithoutPan(flowType, {
          taxIdNumber,
          dob,
          applicationType,
          onboardingType,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          mobileNumber: mobileNumber ? mobileNumber?.toString()?.trim() : '',
          emailId,
          name,
          onboardingIdType,
          onboardingIdTypeOthers,
          flowType,
          fundFlowType,
        })
      )) as unknown as ApplicationProps;
      ONBOARDING_INVESTOR.individual === ONBOARDING_INVESTOR[applicationType]
        ? history.push('/application/distributor-details', { ...(res || {}) })
        : history.push('/non-individual-application', { ...(res || {}) });
      // history.push('enter-otp', {
      //   taxIdNumber,
      //   dob,
      //   applicationType,
      //   onboardingType,
      //   countryCode: countryNameAndCode?.split(':')[1].trim(),
      //   countryNameAndCode,
      //   mobileNumber: phoneNumber,
      //   // emailId:(response || {}).emailId,
      //   name,
      //   onboardingIdType,
      //   onboardingIdTypeOthers,
      //   application,
      //   redirectTo,
      //   flowType: flowType,
      //   ...(response || {}),
      // });
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, values, setValues, errors }) => {
          const { applicationType, onboardingType } = values;
          const label = getFieldLabelForGuardian(onboardingType);
          return (
            <>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
                  {FUND_FLOW_TYPE_MASTER[fundFlowType]} Fund ({FLOW_TYPE_MASTER[flowType]})
                </Typography>
                <Box sx={{ mt: 1.5 }}>
                  <UseRadioGroup
                    formLabel="Onboarding Investor Type *"
                    name={`applicationType`}
                    items={Object.keys(ONBOARDING_INVESTOR)
                      .filter((_option) =>
                        id && redirectTo
                          ? ONBOARDING_INVESTOR[_option] !== ONBOARDING_INVESTOR.non_individual
                          : _option
                      )
                      .map((option) => ({
                        label: ONBOARDING_INVESTOR[option],
                        value: option,
                      }))}
                    onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                      setValues({
                        ...values,
                        applicationType: value,
                        onboardingType: 'normal',
                        mobile: '',
                        countryCode: '+91',
                        countryNameAndCode: 'India: +91',
                      });
                    }}
                  />
                </Box>
                {/* {ONBOARDING_INVESTOR[values.applicationType] === ONBOARDING_INVESTOR.individual && (
                  <Box sx={{ mt: 1.5 }}>
                    <UseRadioGroup
                      formLabel="Account Type *"
                      name={`onboardingType`}
                      items={Object.keys(ACCOUNT_TYPE_MASTER).map((option) => ({
                        label: ACCOUNT_TYPE_MASTER[option],
                        value: option,
                      }))}
                      disabled={!!id}
                    />
                  </Box>
                )} */}
                <MFTextField
                  label={`${label} Name *`}
                  name="name"
                  placeholder="Enter Name"
                  required
                  autoComplete="off"
                />
                {IS_DOB_APPLICABLE_FOR_AMC && (
                  <DatePicker
                    label={`${label} Date of ${
                      isNonIndividualApplication(applicationType) ? 'Incorporation' : 'Birth'
                    } *`}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'DD/MM/YYYY'}
                    name="dob"
                  />
                )}
                <MFSelectField
                  name={`onboardingIdType`}
                  label={`${label} Id Type *`}
                  items={getIdTypeDropDown(values.applicationType).map((item) => ({
                    key: ONBOARDING_ID_TYPES_MASTER[item],
                    value: item,
                  }))}
                />
                {isIdTypeOutOfList(values.onboardingIdType || '') && (
                  <MFTextField
                    label="Id Name *"
                    name="onboardingIdTypeOthers"
                    placeholder="Enter Id Name"
                    required
                    autoComplete="off"
                  />
                )}
                <MFTextField
                  label={`${label} Id Number *`}
                  name="taxIdNumber"
                  placeholder="Enter Id Number"
                  required
                  autoComplete="off"
                />
                {ONBOARDING_INVESTOR[values.applicationType] !==
                  ONBOARDING_INVESTOR.non_individual && (
                  <MFTextField
                    label={`${label} Mobile Number *`}
                    name="mobile"
                    placeholder="Enter Mobile number"
                    onKeyDown={(e) => {
                      preventSpecialCharacters(e);
                    }}
                    startAdornment={
                      <CountryCodesDropDown
                        name={'countryNameAndCode'}
                        value={values.countryNameAndCode}
                      />
                    }
                    regexForFilterValue={nonDigitRegex}
                  />
                )}
                {ENABLE_EMAIL_OTP && (
                  <MFTextField
                    autoComplete="off"
                    // autoFocus
                    label={`${label} ${
                      isNonIndividualApplication(applicationType) ? 'Contact Person' : ''
                    } Email ID *`}
                    name="emailId"
                    placeholder="Enter Email ID"
                    required
                  />
                )}
                {/* {ENABLE_Email_Consent && (
                  <UseRadioGroup
                    formLabel=""
                    name={`onboardingOtpEmailConsent`}
                    defaultValue="otp"
                    items={Object.keys(ONBOARDING_OPTIONS).map((option) => ({
                      label: ONBOARDING_OPTIONS[option],
                      value: option,
                    }))}
                  />
                )} */}

                {/* //   // ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                  //   // ONBOARDING_OPTIONS.email_consent
                  //   //   ? 'Send Email'
                  //   //   : 'Get OTP'
                  // } */}
                <MFSubmitButton label={'Proceed'} />
              </Box>
              {/* <Dialog open={open} onClose={() => setOpen(false)}>
              <Box
                sx={{
                  p: { xs: 2, sm: 8 },
                  borderRadius: '10px',
                  // width: { xs: '70%', sm: '70%' },
                  maxWidth: 800,
                  height: { xs: '90%', md: 'unset' },
                  overflowY: 'auto',
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& .MuiButton-root': {
                      minWidth: 200,
                      fontSize: 16,
                    },
                  }}>
                  <Box sx={{ mb: 8 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset' }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: '#337FC9',
                      textAlign: 'center',
                      width: '70%',
                      mb: 5,
                    }}>
                    Unable to verify the details please contact admin
                  </Typography>
                  <Button
                    // component={RouterLink}
                    variant="contained"
                    onClick={() => {
                      resetForm();
                      setOpen(false);
                    }}
                    sx={{ color: 'common.white' }}>
                    Enter another PAN
                  </Button>
                </Box>
              </Box>
            </Dialog> */}
              {/* <AmlPopup
              handleClose={handleClose}
              amlPopupOpen={amlPopup !== null}
              onSubmit={onSubmit}
              FURTHER_INFORMATION={amlFailedresponse?.FURTHER_INFORMATION}
              EXTERNAL_SOURCES={amlFailedresponse?.EXTERNAL_SOURCES}
              displayDocInfo={true}
            /> */}
            </>
          );
        }}
      </Formik>
    </>
  );
}

// export function EnterMobile({
//   location,
// }: {
//   location: Location<{
//     redirectTo: string;
//     panVerificationToken: string;
//     pan: string;
//     firstHolderName: string;
//     application: ApplicationProps;
//     dob: string;
//   }>;
// }): JSX.Element {
//   const {
//     redirectTo = '',
//     panVerificationToken,
//     pan,
//     firstHolderName = '',
//     application,
//     dob,
//   } = location.state || {};
//   const { id, applicants = [] } = application || {};
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const [disablePOA, setDisablePOA] = useState(false);
//   const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
//   const { enqueueSnackbar } = useSnackbar();
//   const { role = '' } = useSelector((store: RootStateType) => store.auth);

//   const validationSchema1 = yup.object().shape({
//     pan: yup
//       .string()
//       .uppercase()
//       .length(10, 'PAN must be exactly 10 characters')
//       .test('pan', (value, context) => {
//         const fieldValue = value === undefined ? '' : value;
//         const { path, createError } = context;
//         if (!fieldValue) {
//           return createError({
//             message: 'PAN is required',
//             path,
//           });
//         }
//         if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
//           return createError({
//             message: 'invalid PAN',
//             path,
//           });
//         }
//         if (!nonIndividualPanRegex.test(fieldValue)) {
//           return createError({
//             message: 'invalid PAN',
//             path,
//           });
//         }
//         return true;
//       }),
//     emailId: yup.string().when('hasPOA', {
//       is: (value: boolean) => (disablePOA ? true : !value) && ENABLE_EMAIL_OTP,
//       then: yup.string().test('emailId', (value, context) => {
//         const { createError, path, parent } = context;
//         if (!value) {
//           return createError({
//             message: 'Email Id is required',
//             path,
//           });
//         }
//         if (!emailRegex.test(value)) {
//           return createError({
//             message: 'Invalid Email Id',
//             path,
//           });
//         }
//         return true;
//       }),
//     }),

//     mobile: yup.string().when('hasPOA', {
//       is: (value: boolean) => (disablePOA ? true : !value),
//       then: yup.string().test('mobile', (value, context) => {
//         const { createError, path, parent } = context;
//         const codesList = getCountryCodes()
//           .map((codes) => {
//             if (codes.label === parent.countryNameAndCode) {
//               return codes.countryCode;
//             }
//           })
//           .filter((ele) => ele)
//           .toString();
//         if (!value) {
//           return createError({
//             message: 'Mobile number is required',
//             path,
//           });
//         }
//         if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
//           return createError({
//             message: 'Invalid Mobile number',
//             path,
//           });
//         }
//         if (!isValidPhoneNumber(value, codesList as CountryCode)) {
//           return createError({
//             message: 'Invalid Mobile number',
//             path,
//           });
//         }
//         if (applicantMobileNumbers.includes(value)) {
//           return createError({
//             message:
//               'There is already same mobile number for an applicant associated with this application',
//             path,
//           });
//         }
//         return true;
//       }),
//     }),
//     countryNameAndCode: yup
//       .string()
//       .nullable()
//       .when('hasPOA', {
//         is: (value: boolean) => (disablePOA ? true : !value),
//         then: yup.string().test('countryNameAndCode', (value, context) => {
//           const { createError, path, parent } = context;
//           const codesList = getCountryCodes()
//             .map((codes) => {
//               if (codes.label === value) {
//                 return codes.countryCode;
//               }
//             })
//             .filter((ele) => ele)
//             .toString();
//           if (!value) {
//             return createError({
//               message: 'Country Code is required',
//               path,
//             });
//           }
//           if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
//             return createError({
//               message: 'Invalid Mobile number',
//               path,
//             });
//           }

//           return true;
//         }),
//       }),
//   });
//   const initialValues1: MValues = {
//     pan: pan,
//     mobile: '',
//     emailId: '',
//     bypassOtp: false,
//     skipOtpModal: false,
//     hasPOA: false,
//     dob: dob,
//     countryCode: '+91',
//     countryNameAndCode: 'India: +91',
//     onboardingOtpEmailConsent: 'otp',
//   };

//   const handleCreateApplication = async (applicantVerificationToken: string) => {
//     const res = (await dispatch(
//       createApplication({ applicantVerificationToken })
//     )) as unknown as ApplicationProps;
//     history.push('/application/distributor-details', { ...(res || {}) });
//   };

//   const handleSubmit1 = async (values: MValues) => {
//     const {
//       pan,
//       mobile = '',
//       bypassOtp = false,
//       hasPOA,
//       emailId,
//       countryCode = '+91',
//       countryNameAndCode = 'India: +91',
//       onboardingOtpEmailConsent = 'otp',
//     } = values;
//     if (hasPOA) {
//       const poaResponse = (await dispatch(
//         EnablePOA({ panVerificationToken, powerOfAttorney: true })
//       )) as unknown as EnablePOAResponseBody;
//       const { applicantVerificationToken } = poaResponse;
//       await handleCreateApplication(applicantVerificationToken);
//       return;
//     }
//     if (ONBOARDING_OPTIONS[onboardingOtpEmailConsent] === ONBOARDING_OPTIONS.email_consent) {
//       (await dispatch(
//         sendConsentEmail({
//           phoneNumber: mobile.trim(),
//           emailId,
//           panVerificationToken,
//           countryCode: countryNameAndCode?.split(':')[1].trim(),
//           countryNameAndCode,
//           applicationId: id || '',
//         })
//       )) as unknown as SendConsentEmailResponseBody;
//       enqueueSnackbar('Email sent successfully', {
//         variant: 'success',
//         autoHideDuration: 3000,
//       });
//       return history.push(
//         [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
//           ? `/applications-list`
//           : '/applications'
//       );
//     }

//     const response = (await dispatch(
//       sendOtp({
//         phoneNumber: mobile.trim(),
//         emailId,
//         panVerificationToken,
//         countryCode: countryNameAndCode?.split(':')[1].trim(),
//         countryNameAndCode,
//         bypassOtp,
//       })
//     )) as unknown as SendOtpResponseBody;

//     const { applicantVerificationToken, phoneNumber } = response || {};
//     if (bypassOtp) {
//       if (id && redirectTo) {
//         (await dispatch(
//           addJointHolder({ applicantVerificationToken }, id)
//         )) as unknown as ApplicationProps;
//         history.push(redirectTo, { id });
//         return;
//       }
//       handleCreateApplication(applicantVerificationToken);
//       return;
//     }
//     history.push('enter-otp', {
//       pan,
//       unmaskedphone: mobile.trim(),
//       umaskedemailId: emailId,
//       mobile: phoneNumber,
//       panVerificationToken,
//       redirectTo,
//       application,
//       email: (response || {}).emailId,
//       firstHolderName,
//       countryCode: countryNameAndCode?.split(':')[1].trim(),
//       countryNameAndCode,
//       ...(response || {}),
//     });
//   };

//   useEffect(() => {
//     (async function () {
//       const res = (await dispatch(
//         IsApplicableForPOA()
//       )) as unknown as IsApplicableForPOAResponseBody;
//       const { powerOfAttorney } = res;
//       setDisablePOA(
//         application
//           ? application.hasPOA
//             ? application.hasPOA
//             : !application.hasPOA
//           : !powerOfAttorney
//       );
//     })();
//   }, []);

//   return (
//     <>
//       <Formik
//         initialValues={initialValues1}
//         validationSchema={validationSchema1}
//         onSubmit={handleSubmit1}>
//         {({
//           handleSubmit,
//           values,
//           validateForm,
//           isSubmitting,
//           setTouched,
//           setErrors,
//           setFieldValue,
//         }) => (
//           <Box component="form" noValidate onSubmit={handleSubmit}>
//             <Box sx={{ position: 'relative' }}>
//               <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
//                 <CardMedia
//                   component="img"
//                   src="/images/tick.svg"
//                   sx={{ width: '18px', float: 'right' }}
//                 />
//               </Box>
//               <MFTextField
//                 label="PAN"
//                 name="pan"
//                 placeholder="Enter PAN"
//                 required
//                 inputProps={{ style: { textTransform: 'uppercase' } }}
//                 disabled={true}
//               />
//               {IS_DOB_APPLICABLE_FOR_AMC && (
//                 <DatePicker
//                   label={'Date of birth'}
//                   inputLabelStyles={{
//                     transform: 'unset',
//                     fontSize: 14,
//                     fontWeight: 500,
//                     color: 'rgba(0,0,0,0.7)',
//                   }}
//                   placeholder={'Enter Date of birth'}
//                   name="dob"
//                   disabled={true}
//                 />
//               )}

//               <MFCheckbox
//                 name="hasPOA"
//                 label="Power of Attorney"
//                 color="primary"
//                 sx={{
//                   '.MuiTypography-root': {
//                     color: 'primary.main',
//                     fontWeight: 500,
//                     fontSize: 14,
//                     letterSpacing: '0.9625px',
//                   },
//                 }}
//                 disabled={disablePOA}
//               />
//             </Box>
//             {!values.hasPOA && (
//               <>
//                 <MFTextField
//                   label="Mobile Number"
//                   name="mobile"
//                   placeholder="Enter Mobile number"
//                   onKeyDown={(e) => {
//                     preventSpecialCharacters(e);
//                   }}
//                   startAdornment={
//                     <CountryCodesDropDown
//                       name={'countryNameAndCode'}
//                       value={values.countryNameAndCode}
//                     />
//                   }
//                 />
{
  ENABLE_EMAIL_OTP && (
    <MFTextField
      autoComplete="off"
      // autoFocus
      label="Email ID"
      name="emailId"
      placeholder="Enter Email ID"
      required
    />
  );
}
{
  ENABLE_Email_Consent && (
    <UseRadioGroup
      formLabel=""
      name={`onboardingOtpEmailConsent`}
      defaultValue="otp"
      items={Object.keys(ONBOARDING_OPTIONS).map((option) => ({
        label: ONBOARDING_OPTIONS[option],
        value: option,
      }))}
    />
  );
}
//                 <Notes
//                   displayContent={
//                     'Provide the mobile phone number which is registered in KRA database. Applicants Identity details will be fetched from the KRA database.'
//                   }
//                 />
//               </>
//             )}
//             <MFSubmitButton
//               label={
//                 values.hasPOA
//                   ? 'Continue'
//                   : ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
//                     ONBOARDING_OPTIONS.email_consent
//                   ? 'Send Email'
//                   : 'Get OTP'
//               }
//             />
//             {!values.hasPOA &&
//               ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
//                 ONBOARDING_OPTIONS.otp && (
//                 <Button
//                   variant="outlined"
//                   fullWidth
//                   sx={{
//                     color: 'primary.main',
//                     fontWeight: 500,
//                     fontSize: 14,
//                     mt: 0.5,
//                     lineHeight: 1.5,
//                   }}
//                   onClick={async () => {
//                     const error = await validateForm();
//                     if (Object.keys(error).length) {
//                       setTouched(setNestedObjectValues(error, true));
//                       setErrors(error);
//                       return;
//                     }
//                     setFieldValue('skipOtpModal', true);
//                   }}>
//                   Skip OTP Verification
//                 </Button>
//               )}
//             <Dialog open={values.skipOtpModal} onClose={() => setFieldValue('skipOtpModal', false)}>
//               <Box
//                 sx={{
//                   borderRadius: '10px',
//                   // width: { xs: '70%', sm: '70%' },
//                   maxWidth: 800,
//                   height: { xs: '90%', md: 'unset' },
//                   overflowY: 'auto',
//                 }}>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     p: 3,
//                     '& .MuiButton-root': {
//                       minWidth: 200,
//                       fontSize: 16,
//                     },
//                   }}>
//                   <IconButton
//                     onClick={() => setFieldValue('skipOtpModal', false)}
//                     sx={{ alignSelf: 'flex-end' }}>
//                     <CloseIcon fontSize="small" />
//                   </IconButton>
//                   {/* <Box sx={{ mb: 4 }}>
//                     <CardMedia
//                       component="img"
//                       src="/images/warning-icon-red.svg"
//                       sx={{ width: 'unset' }}
//                     />
//                   </Box> */}
//                   <Typography
//                     sx={{
//                       fontSize: 20,
//                       fontWeight: 500,
//                       color: '#337FC9',
//                       textAlign: 'center',
//                       mb: 5,
//                       width: '90%',
//                     }}>
//                     Are you sure you want to Skip OTP Verification?
//                   </Typography>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexWrap: 'wrap',
//                       justifyContent: 'space-around',
//                       width: '100%',
//                     }}>
//                     <Button
//                       variant="outlined"
//                       disabled={isSubmitting}
//                       onClick={() => setFieldValue('skipOtpModal', false)}
//                       sx={{ color: 'primary.main', mb: 2 }}>
//                       Cancel
//                     </Button>
//                     <Button
//                       variant="contained"
//                       sx={{ mb: 2 }}
//                       onClick={() => {
//                         setFieldValue('bypassOtp', true);
//                         handleSubmit();
//                       }}>
//                       Continue
//                     </Button>
//                   </Box>
//                 </Box>
//               </Box>
//             </Dialog>
//           </Box>
//         )}
//       </Formik>
//     </>
//   );
// }

// export function EnterEmailId({
//   location,
// }: {
//   location: Location<{
//     panVerificationToken: string;
//     pan: string;
//     dob: string;
//   }>;
// }): JSX.Element {
//   const { panVerificationToken, pan, dob } = location.state || {};
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const validationSchema1 = yup.object().shape({
//     pan: yup
//       .string()
//       .uppercase()
//       .length(10, 'PAN must be exactly 10 characters')
//       .test('pan', (value, context) => {
//         const fieldValue = value === undefined ? '' : value;
//         const { path, createError } = context;
//         if (!fieldValue) {
//           return createError({
//             message: 'PAN is required',
//             path,
//           });
//         }
//         if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
//           return createError({
//             message: 'invalid PAN',
//             path,
//           });
//         }
//         if (!nonIndividualPanRegex.test(fieldValue)) {
//           return createError({
//             message: 'invalid PAN',
//             path,
//           });
//         }
//         return true;
//       }),
//     emailId: yup
//       .string()
//       .nullable()
//       .matches(emailRegex, 'invalid Email ID')
//       .required('Email is required'),
//   });
//   const initialValues1: EValues = {
//     pan: pan,
//     emailId: '',
//     dob: dob,
//   };

//   const handleSubmit1 = async (values: EValues) => {
//     const { emailId } = values;
//     const response = (await dispatch(
//       SendEmail({ panVerificationToken, emailId })
//     )) as unknown as VerifyOtpResponseBody;
//     const { applicantVerificationToken } = response || {};
//     const res = (await dispatch(
//       createApplication({ applicantVerificationToken })
//     )) as unknown as ApplicationProps;
//     history.push('/non-individual-application', { ...(res || {}) });
//     // history.push('verify-documents', {
//     //   applicantVerificationToken,
//     // });
//   };

//   return (
//     <>
//       <Formik
//         initialValues={initialValues1}
//         validationSchema={validationSchema1}
//         onSubmit={handleSubmit1}>
//         {({ handleSubmit }) => (
//           <Box component="form" noValidate onSubmit={handleSubmit}>
//             <Box sx={{ position: 'relative' }}>
//               <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
//                 <CardMedia
//                   component="img"
//                   src="/images/tick.svg"
//                   sx={{ width: '18px', float: 'right' }}
//                 />
//               </Box>
//               <MFTextField
//                 label="PAN"
//                 name="pan"
//                 placeholder="Enter PAN"
//                 required
//                 inputProps={{ style: { textTransform: 'uppercase' } }}
//                 disabled={true}
//               />
//               {IS_DOB_APPLICABLE_FOR_AMC && (
//                 <DatePicker
//                   label={'Date of Birth/Incorporation'}
//                   inputLabelStyles={{
//                     transform: 'unset',
//                     fontSize: 14,
//                     fontWeight: 500,
//                     color: 'rgba(0,0,0,0.7)',
//                   }}
//                   placeholder={'Enter Date of birth'}
//                   name="dob"
//                   disabled={true}
//                 />
//               )}
//             </Box>
//             <MFTextField
//               autoComplete="off"
//               autoFocus
//               label="Email ID"
//               name="emailId"
//               placeholder="Enter Email ID"
//               required
//             />

//             <Notes
//               displayContent={
//                 'Based on registered email id, we will fetch the documents available with our MF holding that are serviced by kfintech and the data will be prefilled in the application.'
//               }
//             />
//             <MFSubmitButton label={'Proceed'} />
//           </Box>
//         )}
//       </Formik>
//     </>
//   );
// }
